import { render, staticRenderFns } from "./ProductInsights.vue?vue&type=template&id=51d1bf49&scoped=true"
import script from "./ProductInsights.vue?vue&type=script&lang=js"
export * from "./ProductInsights.vue?vue&type=script&lang=js"
import style0 from "./ProductInsights.vue?vue&type=style&index=0&id=51d1bf49&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d1bf49",
  null
  
)

export default component.exports